<template>
  <div>
    <div id="unBindInfoContainer" v-chat-scroll @scroll-end="loadNewData">
      <b-card no-body>
        <b-tabs card v-model="tabIndex">
          <b-tab title="未綁定好友" active>
            <b-list-group flush>
              <b-list-group-item
                v-for="(unBindFriend,index) in UnBindFriends"
                style="padding-left: 0px; padding-right: 0px;"
                :key="index"
              >
                <b-container>
                  <b-row>
                    <b-col cols="8" style="padding-right: 0px;">
                      <div v-html="unBindFriend.cname"></div>
                    </b-col>
                    <b-col cols="4" style="text-align: right;">
                      <b-img
                        @click="goToMobileLeadInfoView(unBindFriend.LeadSn)"
                        src="../../../static/img/open_in_new.png"
                        alt="user-img"
                        style="height: 24px;"
                      ></b-img>
                    </b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab title="應聯好友">
            <b-list-group flush>
              <b-list-group-item
                v-for="(shouldContactFriend,index) in shouldContactFriends"
                style="padding-left: 0px; padding-right: 0px;"
                :key="index"
              >
                <b-container>
                  <b-row>
                    <b-col cols="8" style="padding-right: 0px;">
                      <b-container>
                        <b-row>
                          <b-col cols="12" style="padding-right: 0px;">
                            <div v-html="shouldContactFriend.cname"></div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" style="padding-right: 0px;">
                            {{shouldContactFriend.NextContactDate}}&nbsp;&nbsp;<b-badge v-show="shouldContactFriend.SalesTraceType=='0'" variant="success">客戶</b-badge><b-badge v-show="shouldContactFriend.SalesTraceType=='1'" variant="info">主聯</b-badge>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-col>
                    <b-col cols="4" style="text-align: right;" class="vertical-middle">
                      <b-img
                        @click="goToMobileLeadInfoView(shouldContactFriend.LeadSn)"
                        src="../../../static/img/open_in_new.png"
                        alt="user-img"
                        style="height: 24px;"
                      ></b-img>
                    </b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab title="預約好友">
            <b-list-group flush>
              <b-list-group-item
                v-for="(demoFriend,index) in demoFriends"
                style="padding-left: 0px; padding-right: 0px;"
                :key="index"
              >
                <b-container>
                  <b-row>
                    <b-col cols="8" style="padding-right: 0px;">
                      <b-container>
                        <b-row>
                          <b-col cols="12" style="padding-right: 0px;">
                            <div v-html="demoFriend.cname"></div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" style="padding-right: 0px;">
                            <div v-html="demoFriend.demoTime"></div>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-col>
                    <b-col cols="4" style="text-align: right;" class="vertical-middle">
                      <b-img
                        @click="goToMobileLeadInfoView(demoFriend.LeadSn)"
                        src="../../../static/img/open_in_new.png"
                        alt="user-img"
                        style="height: 24px;"
                      ></b-img>
                    </b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import http from "../../http.js";
import qs from "qs";
export default {
  data() {
    return {
      staff: [],
      tabIndex: 0,
      unBindFriends: [],
      shouldContactFriends: [],
      demoFriends: [],
      unBindFriendIndex: 0,
      unBindFriendIsEnd: false
    };
  },
  created() {
    this.staff = this.GetLoginStaff();
    this.getUnBindFriends(this.unBindFriendIndex);
    this.getShouldContactFriends();
    this.getdemoFriends();
  },
  methods: {
    getUnBindFriends: function(startIndex, lenght) {
      http
        .post(
          "/SCRMApp/GetUnbindedMainContact",
          qs.stringify({
            StartIndex: startIndex,
            staffId: this.staff.staffid
          })
        )
        .then(response => {
          if (response.data.Result.length == 0) {
            this.unBindFriendIsEnd = true;
            return;
          }
          this.unBindFriends.push.apply(
            this.unBindFriends,
            response.data.Result
          );
        })
        .catch(function(error) {
          alert(error);
          window.location.href = "/#/Error";
        });
    },
    goToMobileLeadInfoView: function(leadSn) {
      window.location.href =
        "#/MobileLeadInfoView?ls=" + leadSn;
    },
    loadNewData: function() {
      if (!this.unBindFriendIsEnd && this.tabIndex == 0) {
        this.unBindFriendIndex = this.unBindFriendIndex + 10;
        this.getUnBindFriends(this.unBindFriendIndex);
      }
    },
    getShouldContactFriends: function() {
      http
        .post(
          "/SCRMApp/GetStaffMainContactFollowIUp",
          qs.stringify({
            staffId: this.staff.staffid
          })
        )
        .then(response => {
          if (response.data.Success) {
            this.shouldContactFriends = response.data.Result;
          }
        })
        .catch(function(error) {
          alert(error);
          window.location.href = "/#/Error";
        });
    },
    getdemoFriends: function() {
      http
        .post(
          "/SCRMApp/GetProbationList",
          qs.stringify({
            staffId: this.staff.staffid
          })
        )
        .then(response => {
          if (response.data.Success) {
            this.demoFriends = response.data.Result;
          }
        })
        .catch(function(error) {
          alert(error);
          window.location.href = "/#/Error";
        });
    }
  },
  computed: {
    UnBindFriends: function() {
      return this.unBindFriends;
    }
  }
};
</script>

<style>
#unBindInfoContainer {
  height: calc(100vh - 5px);
  overflow: auto;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 15px;
}

#unBindInfoContainer .card-header {
  background: none;
  border: none;
  padding: 0.75rem 0.6rem 2em;
}

#unBindInfoContainer .card {
  border: none;
}

#unBindInfoContainer .card-body {
  padding: 0;
}

#unBindInfoContainer .card-header .nav-tabs .nav-link {
  border-radius: 50px;
  color: #444;
  font-size: 15px;
  padding: 0.6rem 1rem;
}

#unBindInfoContainer .card-header .nav-tabs .nav-link.active {
  background: #b20404;
  color: #fff;
}

#unBindInfoContainer .nav-tabs .nav-link {
  border: none;
}
#unBindInfoContainer .nav-tabs .nav-item {
  margin-bottom: 0;
  text-align: center;
}

#unBindInfoContainer .list-group-flush .list-group-item {
  background: #f1f1f1;
  color: #929292;
  border: none;
  border-radius: 5px;
  margin: 7px 0;
}

@media (max-width: 340px) {
  #unBindInfoContainer .card-header .nav-tabs .nav-link {
    font-size: 14px;
    padding: 0.6rem;
  }
}
.vertical-middle::before{
  content:'';
  width:0;
  height:100%;
  display:inline-block;
  position:relative;
  vertical-align:middle;
  background:#f00;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/LeadList.vue